import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=20c5e60c&"
import script from "./vip.vue?vue&type=script&lang=js&"
export * from "./vip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c5e60c')) {
      api.createRecord('20c5e60c', component.options)
    } else {
      api.reload('20c5e60c', component.options)
    }
    module.hot.accept("./vip.vue?vue&type=template&id=20c5e60c&", function () {
      api.rerender('20c5e60c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pay/vip.vue"
export default component.exports